import OverlayLoader from "components/loader/OverlayLoader";
import InfoIconTooltip from "components/tooltip/InfoIconTooltip";
import InboxPreviewItem from "../inboxPreviewItem/InboxPreviewItem";
import { LinkPrimaryArrow } from "components/link/Link";
import { Thread } from "models/inbox/inbox";
import { isInternalUser } from "common/MetaActions";

import "./InboxPreview.scss";

type Props = {
  threads: Thread[];
  isLoading: boolean;
};

export default function InboxPreview({ threads, isLoading }: Props) {
  return (
    <section aria-label="Olästa meddelanden" className="inboxPreview">
      <h1 className="m-0 d-flex align-items-center">
        Olästa meddelanden{" "}
        <InfoIconTooltip className="ml-3">
          Här visas de fem senast uppdaterade konversationerna. När du klickar
          på meddelandet öppnas konversationen i fliken Inkorg där du kan se
          alla meddelandena. När du har fått ett nytt meddelande i en
          konversation visas den här.
        </InfoIconTooltip>
      </h1>
      <hr className="header-border" />

      <OverlayLoader isLoading={isLoading}>
        <>
          {threads.map((thread) => {
            const link = `/inbox/${isInternalUser() ? "all" : "my"}/thread/${encodeURIComponent(thread.threadId)}`;
            return (
              <InboxPreviewItem
                key={thread.threadId}
                thread={thread}
                link={link}
              />
            );
          })}
          {threads.length === 0 && <p>Du har inga olästa meddelanden</p>}
        </>
      </OverlayLoader>

      <hr className="footer-border" />
      <LinkPrimaryArrow to="/inbox">Till inkorgen</LinkPrimaryArrow>
    </section>
  );
}
